const EMI_LIST_TYPE_MAP = {
    SAVED: "savedCardEmiPlans",
    NEW: "emiPlans",
};

const TITLE_MAP: Record<string, string> = {
    [EMI_LIST_TYPE_MAP.SAVED]: "Saved Cards",
    [EMI_LIST_TYPE_MAP.NEW]: "Add New Cards",
};

export { EMI_LIST_TYPE_MAP, TITLE_MAP };
